/* tslint:disable */
/* eslint-disable */
import React from 'react';
import { Box, Typography, Link, Chip } from '@material-ui/core';
import { makeStyles, createStyles } from '@material-ui/styles';
import { DataGrid, GridColumns } from '@material-ui/data-grid';
import { useCommonStyles } from './AdminConsoleBilling';
import { DateTime } from 'luxon';
import { GetApp } from '@material-ui/icons';

type Props = {
  invoices: any[];
};

export const useStyles = makeStyles(() =>
  createStyles({
    root: {
      height: '500px',
      border: 'none',
      '& .MuiDataGrid-columnsContainer': {
        justifyContent: 'center',
        backgroundColor: '#F9F9F9',
      },
      '& .MuiDataGrid-columnSeparator': {
        display: 'none',
      },
      '& .MuiDataGrid-selectedRowCount': {
        visibility: 'hidden',
      },
      '& .MuiDataGrid-columnHeader--moving': {
        background: 'none',
      },
      '& .MuiDataGrid-columnHeaderTitleContainer': {
        padding: 0,
      },
    },
    row: {
      '&:nth-child(even)': {
        backgroundColor: '#F9F9F9',
      },
    },
  })
);

export const BillingHistory = (props: Props) => {
  const classes = useCommonStyles();
  const tableClasses = useStyles();
  const { invoices } = props;
  const columns: GridColumns = [
    {
      field: 'period_end',
      headerName: 'Date',
      flex: 1,
      minWidth: 200,
      renderCell: ({ row }: any) => DateTime.fromJSDate(new Date(row.period_end * 1000)).toFormat('LLL dd, yyyy'),
    },
    {
      field: 'description',
      headerName: 'Description',
      flex: 1,
      minWidth: 200,
      renderCell: ({ row }: any) => {
        // Try to get line items from the invoice
        if (row.lines?.data?.length > 0) {
          return (
            <Box>
              {row.lines.data.map((line: any, index: number) => {
                // Extract clean product name from description
                let itemName = line.description || line.plan?.name || 'Subscription';

                // Remove quantity prefix (e.g., "1 × ")
                itemName = itemName.replace(/^\d+\s*×\s*/, '');

                // Remove pricing suffix (e.g., " (at $19.00 / month)")
                itemName = itemName.replace(/\s*\(at\s+[^)]+\)$/, '');

                return (
                  <Typography key={index} style={{ fontSize: '14px', lineHeight: '1.3' }}>
                    {itemName}
                  </Typography>
                );
              })}
            </Box>
          );
        }
        // Fallback to the basic description
        return row.description || 'Invoice';
      },
    },
    {
      field: 'total',
      headerName: 'Total',
      flex: 1,
      minWidth: 150,
      renderCell: ({ row }: any) => `$${(row.total / 100).toFixed(2)}`,
    },
    {
      field: 'status',
      headerName: 'Status',
      flex: 1,
      minWidth: 200,
      renderCell: ({ row }: any) => (
        <Box display='flex' flexDirection='column' alignItems='flex-start' style={{ gap: '2px' }}>
          <Chip
            label={row.status === 'paid' ? 'Paid' : row.status === 'open' ? 'Due' : row.status}
            size='small'
            style={{
              backgroundColor: row.status === 'paid' ? '#d4edda' : '#f8d7da',
              color: row.status === 'paid' ? '#155724' : '#721c24',
              textTransform: 'capitalize',
              height: '20px',
            }}
          />
          {row.invoice_pdf && (
            <Link
              href={row.invoice_pdf}
              target='_blank'
              rel='noopener'
              style={{
                display: 'flex',
                alignItems: 'center',
                textDecoration: 'none',
                color: '#1976d2',
                fontSize: '11px',
                lineHeight: '1',
              }}
            >
              <GetApp style={{ fontSize: '12px', marginRight: '2px' }} />
              Download
            </Link>
          )}
        </Box>
      ),
    },
  ];

  return (
    <Box>
      <Typography className={classes.sectionHeading} style={{ marginBottom: '16px' }}>
        Invoice History
      </Typography>
      <Box style={{ minHeight: 400 }}>
        <DataGrid
          columns={columns}
          rows={invoices}
          classes={tableClasses}
          autoPageSize
          disableSelectionOnClick
          pageSize={10}
          rowsPerPageOptions={[10, 20, 50]}
        />
      </Box>
    </Box>
  );
};
